/**
 * Maps database FieldType ID to HTML input type string
 * @param {number|string} typeId - FieldType ID from database
 * @returns {string} - Lowercase HTML input type string
 */
export const getHtmlInputType = (typeId) => {
  switch (Number(typeId)) {
    case 1: return "text";
    case 2: return "textarea";
    case 3: return "number";
    case 4: return "date";
    case 5: return "checkbox";
    case 6: return "radio";
    case 7: return "select";
    case 8: return "email";
    case 9: return "password";
    case 10: return "phone";
    case 11: return "editor";
    case 12: return "attachments";
    case 13: return "select";
    default: return "text";
  }
};
